import React from 'react';
import Hero from '../components/Hero';
import JobListings from '../components/JobListings';
import APEXSection from '../components/APEXSection';

const HomePage = () => {
  return (
    <div className="mx-auto w-full max-w-[1600px] px-6 duration-300 md:px-8 lg:px-14">
      <Hero />
      <JobListings />
      <APEXSection />
    </div>
  );
};

export default HomePage;
